module.exports = __webpack_public_path__ + "static/umeed-34c4e980ebec15ea3bb678bd22df16b5.svg";